<template>
  <div id="adminDetalleCajaChica">
    <v-toolbar>
      <img src="@/assets/logo_javer.png" height="60" width="auto">
      <v-spacer></v-spacer>
      <v-toolbar-title>Detalle de fondo fijo de caja</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6>
            <v-container fluid>
              <h3 class="grey--text">GENERAL</h3><br/>
              <v-radio-group v-model="detalle.cajaChica.area" :mandatory="false">
                <div slot="label"><strong>Área</strong></div>
                <v-radio label="Oficinas administrativas" color="primary" value="oficinas_administrativas"></v-radio>
                <v-radio label="Oficinas comerciales" color="primary" value="oficinas_comerciales"></v-radio>
              </v-radio-group>
              <br/>
              <h3 class="grey--text">RESPONSABLE</h3><br/>
              <v-text-field v-model="detalle.cajaChica.nombre" label="Nombre"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.puesto" label="Puesto"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.departamento" label="Departamento"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.oficina" label="Oficina"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.centro" label="Centro de costos"></v-text-field>
              <br/>
              <h3 class="grey--text">FIRMAS</h3><br/>
              <v-list three-line>
                <template v-for="(item, i) in detalle.cajaChica.firmas">
                  <v-list-tile class="pb-2 pt-2">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                      <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-show="(i + 1) < detalle.cajaChica.firmas.length"></v-divider>
                </template>
              </v-list>
            </v-container>
          </v-flex>
          <v-flex xs6>
            <v-container fluid>
              <h3 class="grey--text">FONDO FIJO</h3><br/>
              <v-text-field v-model.lazy="detalle.cajaChica.importe" label="Importe" prefix="$" suffix="MXN"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.letra" label="Importe con letra"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.detalle" label="Detalle"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.empresa" label="Empresa"></v-text-field>
              <v-text-field v-model="detalle.cajaChica.observaciones" label="Observaciones"></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import axios from 'axios'
import services from '@/config/services'

export default {
  name: 'adminDetalleCajaChica',
  data: () => ({
    loading: false,
    detalle: {
      cajaChica: {
        estado: '',
        area: null,
        nombre: '',
        puesto: '',
        departamento: '',
        oficina: '',
        centro: '',
        importe: '',
        letra: '',
        detalle: '',
        empresa: '',
        observaciones: '',
        firmas: [],
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null },
        incremento: {
          id: '',
          importe: '',
          letra: '',
          observaciones: '',
          pagare: { nombre: '', data: null },
          responsiva: { nombre: '', data: null },
          firmas: []
        }
      }
    }
  }),
  mounted() {
    var token = this.getQueryVariable('token')
    var id = this.getQueryVariable('id')
    this.$session.start()
    this.$session.set('jwt', token)
    this.showDetailReq(id);
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getQueryVariable(variable) {
      let query = window.location.search.substring(1)
      let vars = query.split("&")
      for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=")
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return(false)
    },
    prepareDetailReq(data) {
      this.detalle.cajaChica.nombre = data.usuario.nombre + ' ' + data.usuario.apellido_paterno + ' ' +
                                      data.usuario.apellido_materno
      this.detalle.cajaChica.nombre = this.detalle.cajaChica.nombre.trim();
      this.detalle.cajaChica.puesto = data.usuario.puesto
      this.detalle.cajaChica.departamento = data.usuario.departamento
      this.detalle.cajaChica.oficina = data.usuario.ubicacion
      this.detalle.cajaChica.estado = data.solicitud.estado
      this.detalle.cajaChica.area = data.solicitud.area
      this.detalle.cajaChica.centro = data.solicitud.centro
      this.detalle.cajaChica.importe = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.cajaChica.letra = data.solicitud.letra
      this.detalle.cajaChica.detalle = data.solicitud.detalle
      this.detalle.cajaChica.empresa = data.solicitud.empresa
      this.detalle.cajaChica.observaciones = data.solicitud.observaciones
      this.detalle.cajaChica.firmas = data.firmas
      this.dialogDetReq = true
    },
    showDetailReq(id) {
      this.loading = true
      let data = {
        id: id,
        tipo: 'Alta'
      }
      this.ws('get', 'adminDetalleMovimientoCajaChica', data)
        .then(res => {
          if (res.ok) {
            this.prepareDetailReq(res.data)
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
